import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type ReportingStandard } from 'types/models';

export interface ReportingStandardsState extends EntityState<ReportingStandard>, ActiveState {}

const store = createEntityStore<ReportingStandardsState>({}, { resettable: true, name: 'reportingStandards' });

export default store;
